import {SideBaseModule} from "../SideBaseModule";
import {HeightLocationModule} from "../HeightLocationModule";

export const CompositionModuleFilterData = [
    {
        idFromColumnFilter: "priority",
        id: "priority",
    },
    {
        "idFromColumnFilter": "name",
        "id": "name"
    },
    {
        "idFromColumnFilter": "width",
        "id": "width",
    },
    {
        "idFromColumnFilter": "height",
        "id": "height",
    },
    {
        "idFromColumnFilter": "depth",
        "id": "depth",
    },
    {
        "idFromColumnFilter": "coordinateXPoint",
        "id": "coordinateXPoint",
    },
    {
        "idFromColumnFilter": "coordinateYPoint",
        "id": "coordinateYPoint",
    },
    {
        "idFromColumnFilter": "sideBaseModule",
        "id": "sideBaseModule",
        "filterFn": (value, filterValue) => SideBaseModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "heightLocation",
        "id": "module",
        "field": "heightLocation",
        "filterFn": (value, filterValue) => HeightLocationModule[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]